import React from "react";
import styled from "styled-components";

const ThumbnailFrame = styled.div`
    height: ${p => p.$height || "4.5rem"};
    aspect-ratio: ${p => p.$aspectRatio || "9 / 16"};
    border: ${p => p.$border || "1px solid var(--calendar-border, #D8DEEC)"};
    border-radius: ${p => p.$borderRadius || "7px"};
    background: ${p => p.$background || "var(--calendar-surface, #FFFFFF)"};
    box-shadow: ${p => p.$boxShadow || "0px 3px 6px #0000001F"};
    overflow: hidden;
    margin: 0 auto;
`;

const ThumbnailImage = styled.img`
    width: 100%;
    height: 100%;
    display: block;
    object-fit: ${p => p.$objectFit || "cover"};
    object-position: center;
`;

export default function AspectRatioImageThumbnail({
    src,
    alt,
    height,
    aspectRatio,
    border,
    borderRadius,
    background,
    boxShadow,
    objectFit
}) {
    if (!src) {
        return null;
    }

    return (
        <ThumbnailFrame
            $height={height}
            $aspectRatio={aspectRatio}
            $border={border}
            $borderRadius={borderRadius}
            $background={background}
            $boxShadow={boxShadow}
        >
            <ThumbnailImage src={src} alt={alt || ""} $objectFit={objectFit} />
        </ThumbnailFrame>
    );
}
